.geoMapPinPopup {
  border-radius: var(--border-radius-04);
  box-shadow: var(--elevation-3);
  border: 1px solid #d0d0d0;

  .popupContainer {
    display: flex;
    flex-direction: column;
    min-width: 250px;
    gap: var(--spacing-04);
    padding: var(--spacing-12);

    .popupContent {
      display: flex;
      flex-direction: column;
      gap: var(--spacing-08);

      .content {
        display: flex;
        align-items: center;
        gap: var(--spacing-16);
        justify-content: space-between;
      }
    }
  }
}
